<template>
    <v-card>
        <v-card-title primary-title>
           아들 이름: {{ name }}
        </v-card-title>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="call">call</v-btn>
        </v-card-actions>
    </v-card>
        
  
</template>
<script>
export default {
    // mother.vue에서 넘어온 name을 props로 받은 후
    // {{ name }} 으로 사용한다.
    props : [ 'name' ],
    methods : {
        call() {
            // $emit 을 사용하여 자식에서 부모한테 값을 전달할 수 있음
            this.$emit('help')

        }
    }
}
</script>